import api from './api';
import types from './mutation-types';

export default {
	/**commit mutations*/
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, { key, value });
	},
	setPagingInfo_({ commit }, { key, value }) {
		commit(types.PAGING_INFO, { key, value });
	},
	setState_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value });
	},
	/**call API */
	async getCommCodes_({ commit, rootState }, { key, codeType }) {
		try {
			const { header, body } = await api.getCommCodes(codeType, rootState['commonStore'].user.plantCd);
			if (header.code === 0) {
				const list = [];
				body.length && body.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
				await commit(types.DEFAULT_ASSIGN, { key, value: list });
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			return error?.header;
		}
	},
	async getList_({ commit, state }) {
		try {
			const { searchParams } = state;
			const data = await api.getList({ searchParams });
			if (data?.header?.code === 0) {
				const { resultList, result, maxCnt } = data.body;
				commit(types.DEFAULT_ASSIGN, { key: 'maxCnt', value: Number(maxCnt) });
				commit(types.DEFAULT_ASSIGN, { key: 'sumCnt', value: Number(result.totCnt) });
				commit(types.DEFAULT_ASSIGN, { key: 'graphList', value: resultList });
				commit(types.DEFAULT_ASSIGN, { key: 'resultList', value: result });
			} else if (data.header.code === 3) {
			}
			return data?.header;
		} catch (error) {
			// return error.header || error;
			throw new Error(error.header.message || error);
		}
	}
};
